import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
});
